import React from 'react';
import ServiceDetail from './ServiceDetail';
import { detailedServices } from '../data/servicesData';

export const ReportingDashboardService = () => {
  return <ServiceDetail service={detailedServices[0]} />;
};

export const DataEngineeringService = () => {
  return <ServiceDetail service={detailedServices[1]} />;
};

export const DataScienceService = () => {
  return <ServiceDetail service={detailedServices[2]} />;
};

export const SystemIntegrationService = () => {
  return <ServiceDetail service={detailedServices[3]} />;
};

export const DataLakehouseService = () => {
  return <ServiceDetail service={detailedServices[4]} />;
};

export const DataModelingService = () => {
  return <ServiceDetail service={detailedServices[5]} />;
};

export const CloudPlatformsService = () => {
  return <ServiceDetail service={detailedServices[6]} />;
};

export const DatabaseService = () => {
  return <ServiceDetail service={detailedServices[7]} />;
}; 